(function () {
	// Throttle + defer slider (re)initialization to avoid race conditions causing click issues
	let lastRun = 0;
	let timer = null;
	const MIN_GAP = 250; // ms between consecutive inits

	function doInit() {
		try {
			if (typeof subSliderInit === 'function') subSliderInit(true, 16);
			if (typeof sliderInit === 'function') sliderInit(true);
			if (typeof popupSliderInit === 'function') popupSliderInit(true);
		} catch (e) {
			// Silent to avoid console noise in production; underlying functions may not exist on some pages
		} finally {
			lastRun = Date.now();
			timer = null;
		}
	}

	function scheduleInit(delay = 80) {
		const now = Date.now();
		const wait = Math.max(delay, lastRun + MIN_GAP - now);
		if (timer) clearTimeout(timer);
		timer = setTimeout(doInit, wait);
	}

	function swiperInit() {
		scheduleInit(80);
	}

	// Expose for other scripts (e.g., dynamic tab/page injections) to trigger safely
	window.swiperInit = swiperInit;

	// Re-init when a Shopify section loads (AJAX/Customizer)
	document.addEventListener('shopify:section:load', function () {
		swiperInit();
	});

	// Run after DOM is ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => swiperInit(), { once: true });
	} else {
		swiperInit();
	}
})();
